<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Storage</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <div v-for="storage in storages" :key="storage.mount">
          <label>{{ storage.mount }} - ({{ storage.used }}B / {{ storage.size }}B)</label>
          <div class="progress">
            <div class="progress-bar" role="progressbar" :style="'width: ' + storage.used_percentage  + '%;'" :aria-valuenow="storage.used_percentage" aria-valuemin="0" aria-valuemax="100">{{ storage.used_percentage }}%</div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'storage',
  computed: mapGetters({
    storages: 'allStorages'
  }),
  created () {
    this.$store.dispatch('getStorages')
  }
}
</script>

<style scoped>

</style>
